import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function DealGalleryItem(_ref) {
  var imageUrl = _ref.imageUrl,
    videoUrl = _ref.videoUrl,
    previewItem = _ref.previewItem,
    setPreviewItem = _ref.setPreviewItem;
  return /*#__PURE__*/_jsx("div", {
    className: "max-w-[70px] w-[70px] min-w-[70px] mt-0 mr-1 lg:mr-0 lg:mt-1 rounded ".concat(previewItem == videoUrl || previewItem == imageUrl ? 'border-2 border-primary shadow-xl' : ''),
    children: /*#__PURE__*/_jsx("img", {
      src: imageUrl,
      onClick: function onClick() {
        return setPreviewItem(!!videoUrl ? videoUrl : imageUrl);
      },
      onMouseOver: function onMouseOver() {
        return setPreviewItem(!!videoUrl ? videoUrl : imageUrl);
      },
      className: "object-contain cursor-pointer rounded w-full "
    })
  });
}
export default DealGalleryItem;